// Wing-side word helpers. Roman numerals for the past panel's chapter roll-call
// (archival register). spellSmall renders the reviews-due secondary line as
// marginalia ("twelve await") rather than a notification ("12 reviews"). The
// center panel imports spellSmall for its cardinal counts and keeps only its
// ordinal helpers private (a different contract — "the eighty-first frame").
const ONES = [
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
]
const TENS = [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
]
const ROMAN = [
    '',
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X',
    'XI',
    'XII',
]

export function spellSmall(n: number): string {
    if (n < 0 || n >= 100) return String(n)
    if (n < 20) return ONES[n]!
    const t = Math.floor(n / 10),
        r = n % 10
    return r === 0 ? TENS[t]! : `${TENS[t]}-${ONES[r]}`
}

export function toRoman(n: number): string {
    if (n >= 1 && n < ROMAN.length) return ROMAN[n]!
    return String(n)
}
